import { render } from "./EdificacionesInstrumentadas.vue?vue&type=template&id=71294b5a"
import script from "./EdificacionesInstrumentadas.vue?vue&type=script&lang=js"
export * from "./EdificacionesInstrumentadas.vue?vue&type=script&lang=js"

import "./EdificacionesInstrumentadas.vue?vue&type=style&index=0&id=71294b5a&lang=css"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__